 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import LOVE_1 from '@/components/love_1'
 import TITLE_PAGE from '@/components/title_page'
 import DEDICATION from '@/components/Dedication'
 import NAV from '@/components/nav'
 import INTRODUCTION_SURRENDER_WH from '@/components/Introduction_Surrender_Wh'
 import THE_TERMS_OF_OUR_PEACE_TR from '@/components/The_Terms_of_Our_Peace_Tr'
 import ARTICLE_I_WHITE_PEOPLE_SH from '@/components/Article_I_White_People_Sh'
 import ARTICLE_II_HISTORY_BOOKS_ from '@/components/Article_II_History_Books_'
 import ARTICLE_III_WE_SHALL_ENDE from '@/components/Article_III_We_Shall_Ende'
 import ARTICLE_IV_WE_SHALL_DEAL_ from '@/components/Article_IV_We_Shall_Deal_'
 import ARTICLE_V_WE_SHALL_BE_UN from '@/components/Article_V_We_Shall_Be_Un-'
 import ARTICLE_VI_WE_ARE_PART_OF from '@/components/Article_VI_We_Are_Part_of'
 import LOVE_2 from '@/components/love_2'
 import CONCLUSION from '@/components/Conclusion'
 import SIGNATURE_PAGE from '@/components/Signature_Page'
 import ACKNOWLEDGMENTS from '@/components/Acknowledgments'
 import ABOUT_THE_AUTHOR from '@/components/About_the_Author'
 import CARD_PAGE from '@/components/Card_Page'
 import BOOK_PERK_AD from '@/components/Book_Perk_Ad'
 import COPYRIGHT_ELECTRONIC from '@/components/Copyright_electronic'
 import ABOUT_THE_PUBLISHER from '@/components/About_the_Publisher'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/title_page",
 			"name" : "title_page",
 			"component" : TITLE_PAGE
 		},
 		{
 			"path" : "/Dedication",
 			"name" : "Dedication",
 			"component" : DEDICATION
 		},
 		{
 			"path" : "/nav",
 			"name" : "nav",
 			"component" : NAV
 		},
 		{
 			"path" : "/Introduction_Surrender_Wh",
 			"name" : "Introduction_Surrender_Wh",
 			"component" : INTRODUCTION_SURRENDER_WH
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js